<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Zelle
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Zelle
    v-layout(align-start='', justify-start='', row='', wrap='' fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-progress-circular(v-if='loading' indeterminate='', color='primary' style='margin-top: 20px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:white; padding: 15px;")
          v-layout(row, wrap, align-center)
            v-flex(xs12, md4, class="px-2")
              v-text-field(v-model="search", append-icon="search", label="Buscar por Nombre, Código o Comercio", single-line, hide-details)
            v-flex(xs12, md4, class="px-2")
              v-select(v-model="statusFilter", :items="statusOptions", label="Filtrar por Estatus", clearable)
            v-flex(xs12, md4, class="px-2")
              v-menu(v-model="dateMenu", :close-on-content-click="false", :nudge-right="40", lazy, transition="scale-transition", offset-y, full-width, min-width="290px")
                template(v-slot:activator="{ on }")
                  v-text-field(v-model="dateFilter", label="Filtrar por Fecha", prepend-icon="event", readonly, v-on="on", clearable, @click:clear="dateFilter = null")
                v-date-picker(v-model="dateFilter", @input="dateMenu = false", locale="es-es")
        v-data-table.elevation-1(:headers='headers', :items='filteredResults', :loading='loading', style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td(v-if='props.item.nombre') {{props.item.nombre}}
            td(v-else) - -
            td(v-if='props.item.monto') ${{props.item.monto}}
            td(v-else) - -
            td {{ formatDateTime(props.item) }}
            td
              v-chip(:color="getColor(props.item.estatus)" dark) {{props.item.estatus}}
            td(v-if='props.item.cliente') {{props.item.cliente}}
            td(v-else) - -
            td(v-if='props.item.nombre_cliente') {{props.item.nombre_cliente}}
            td(v-else) - -
            td
              v-btn(icon, small, @click="showDetails(props.item)")
                v-icon(color="green") visibility

  //===========================================================Modal Detalles==============================================================================================
  v-dialog(v-model='detailsDialog', max-width='600px')
    v-card
      v-card-title.headline Detalles del Pago
      v-card-text
        v-container(grid-list-md)
          v-layout(wrap)
            v-flex(xs12, sm6)
              p #[strong Nombre:] {{ selectedItem.nombre }}
            v-flex(xs12, sm6)
              p #[strong Monto:] ${{ selectedItem.monto }}
            v-flex(xs12, sm6)
              p #[strong Fecha y Hora:] {{ formatDateTime(selectedItem) }}
            v-flex(xs12, sm6)
              p #[strong Estatus:] {{ selectedItem.estatus }}
            v-flex(xs12, sm6)
              p #[strong Codigo Comercio:] {{ selectedItem.cliente }}
            v-flex(xs12, sm6)
              p #[strong Nombre Comercio:] {{ selectedItem.nombre_cliente }}
            v-flex(xs12, v-if="selectedItem.comprobante")
              v-img(:src="selectedItem.comprobante")
      v-card-actions
        v-spacer
        v-btn(color='blue darken-1', text, :href="selectedItem.comprobante", target="_blank", v-if="selectedItem.comprobante") Ver Comprobante
        v-btn(color='orange darken-1', text, @click="processPaymentFromModal(selectedItem)", v-if="selectedItem.estatus === 'Asignado'") Procesar Pago
        v-btn(color='grey darken-1', text, @click='detailsDialog = false') Cerrar

  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';

export default {
  name: "Zelle",
  data: () => ({
    search: '',
    statusFilter: null,
    dateFilter: null,
    dateMenu: false,
    statusOptions: ['Pendiente', 'Asignado', 'Procesado'],
    resultados: [],
    dialog4: false,
    loading: true,
    detailsDialog: false,
    selectedItem: {},
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Monto", value: "monto" },
      { text: "Fecha y Hora", value: "fecha" },
      { text: "Estatus", value: "estatus" },
      { text: "Codigo Comercio", value: "cliente" },
      { text: "Nombre Comercio", value: "nombre_cliente" },
      { text: "Acciones", value: "acciones", sortable: false },
    ],
  }),

  computed: {
    filteredResults() {
      let filtered = this.resultados;

      // Search filter
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        filtered = filtered.filter(item => {
          const nombre = (item.nombre || '').toLowerCase();
          const cliente = (item.cliente || '').toLowerCase();
          const nombreCliente = (item.nombre_cliente || '').toLowerCase();
          return nombre.includes(searchLower) || cliente.includes(searchLower) || nombreCliente.includes(searchLower);
        });
      }

      // Status filter
      if (this.statusFilter) {
        filtered = filtered.filter(item => item.estatus === this.statusFilter);
      }

      // Date filter
      if (this.dateFilter) {
        filtered = filtered.filter(item => {
          return item.fecha && moment(item.fecha).isSame(this.dateFilter, 'day');
        });
      }

      return filtered;
    }
  },

  created() {
    this.initialize();
  },
  methods: {
    formatDateTime(item) {
      if (item.fecha) {
        return moment(item.fecha).format('DD/MM/YYYY hh:mm A');
      }
      return '- -';
    },
    getColor(status) {
      if (status === 'Asignado') return 'orange'
      else if (status === 'Pendiente') return 'red'
      else return 'green'
    },
    showDetails(item) {
      this.selectedItem = Object.assign({}, item);
      this.detailsDialog = true;
    },
    processPaymentFromModal(item) {
      this.detailsDialog = false;
      this.processPayment(item);
    },
    processPayment(item) {
      this.$swal.fire({
        title: '¿Estás seguro?',
        text: `¿Deseas marcar este pago como "Procesado"?`,
        type: 'warning', // Corregido de 'icon' a 'type'
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, procesar!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) { // Corregido de 'result.isConfirmed' a 'result.value'
          this.dialog4 = true;
          Api.put(`zelle/process/${item._id}`, {}).then(() => {
            this.dialog4 = false;
            this.$swal.fire(
              '¡Procesado!',
              'El pago ha sido marcado como procesado.',
              'success'
            );
            this.initialize();
          }).catch(err => {
            console.log(err);
            this.dialog4 = false;
            this.$swal.fire(
              "¡Error!",
              "No se pudo procesar el pago.",
              "error"
            );
          });
        }
      })
    },
    initialize() {
      this.loading = true;
      this.dialog4 = true;
      Api.get("zelle").then(res => {
        this.resultados = res.data;
        this.dialog4 = false;
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.$swal.fire(
          "¡Atención!",
          "Error de conexión, intente nuevamente.",
          "error"
        );
        this.dialog4 = false;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
</style>
